var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTagForm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.5625 20.1875C34.0625 20.7292 34.3125 21.375 34.3125 22.125C34.3125 22.8333 34.0625 23.4583 33.5625 24L24 33.5625C23.5 34.0625 22.875 34.3125 22.125 34.3125C21.375 34.3125 20.75 34.0625 20.25 33.5625L8.4375 21.75C7.9375 21.25 7.6875 20.625 7.6875 19.875V10.3125C7.6875 9.60417 7.9375 9 8.4375 8.5C8.97917 7.95833 9.60417 7.6875 10.3125 7.6875H19.875C20.625 7.6875 21.25 7.9375 21.75 8.4375L33.5625 20.1875ZM13.6875 15.6875C14.2292 15.6875 14.6875 15.5 15.0625 15.125C15.4792 14.7083 15.6875 14.2292 15.6875 13.6875C15.6875 13.1042 15.4792 12.625 15.0625 12.25C14.6875 11.875 14.2292 11.6875 13.6875 11.6875C13.1042 11.6875 12.625 11.875 12.25 12.25C11.875 12.625 11.6875 13.1042 11.6875 13.6875C11.6875 14.2292 11.875 14.7083 12.25 15.125C12.625 15.5 13.1042 15.6875 13.6875 15.6875Z",
    fill: "#000E4B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTagForm);
export default __webpack_public_path__ + "static/media/TagForm.4070e16f8ed8ee4d73ae08550b151678.svg";
export { ForwardRef as ReactComponent };